export var LOST_BUSINESS_NOTIFIER_NOTIFY_PATH = '/_serverless/wixstores-lost-business-notifier/lost-business';
//# sourceMappingURL=constants.js.map